export default "__VITE_ASSET__B5itw5$j__"